<template>
  <div class="pc public" :class="end">
    <div class="top">
      <div class="top_button">
        <!-- <div class="top_button_left public"></div> -->
        <a
          v-if="ism == 'PC'"
          href="//mz.zlongame.com/main.shtml"
          class="top_button_left public"
          target="_blank"
          >进入官网</a
        >
        <div
          v-if="!role_id"
          class="top_button_right public"
          @click="loginClick"
        >
          登录
        </div>
        <div
          v-if="role_id"
          class="top_button_right_exit public"
          @click="exitClick"
        >
          退出登录
        </div>
        <div v-if="role_id" class="username">{{ role_name }}</div>
      </div>
      <div class="uplodbox">
        <div class="uplod">
          <div class="uplod_left public" @click="uplodClick('9')"></div>
          <div class="uplod_right public" @click="uplodClick('10')"></div>
        </div>
      </div>
    </div>

    <!-- 获奖作品 -->
    <winning v-if="end == 'end'" :ism="ism"></winning>
    <!-- 奖品区 -->
    <reward :end="end" :ism="ism" @tipchange="tipchange"></reward>
    <!-- 作品列表 -->
    <works
      :ism="ism"
      :role_id="role_id"
      :endFlag="endFlag"
      ref="works"
      @loginflagChang="loginflagChang"
      @lickAdd="lickAdd"
      @tipchange="tipchange"
      @promptTip="promptTip"
    ></works>
    <!-- 弹框 -->
    <div class="tipbox" v-if="tipflag">
      <!-- 作品详情 -->
      <div class="tip_worksbox" v-if="tip == 1">
        <div class="tip_works">
          <div class="tip_worksbox_guan public" @click="tipchange(false)"></div>
          <div class="tip_works_content">
            <div class="tip_works_left">
              <div class="tip_works_left_top">
                <img :src="tiplist.m_info.thumbnail_url" />
              </div>
              <div
                class="fullscreen_icon public"
                @click="fullscreenClick(tiplist)"
              ></div>
              <div class="tip_works_bottom">
                <div class="tip_works_bottom_top">
                  作品名称：{{ tiplist.m_name }}
                </div>
                <div class="tip_works_bottom_author">
                  <div class="tip_works_bottom_author_left">
                    作者：{{ tiplist.author_name }}
                  </div>
                  <div
                    class="tip_works_bottom_author_right public"
                    v-if="ism == 'PC'"
                    @click="lickClick"
                  >
                    {{ tiplist.like_num }}
                  </div>
                </div>
                <div class="tip_works_bottom_author">
                  <div class="tip_works_bottom_bottom">
                    作品简介：{{ tiplist.tags }}
                  </div>
                  <div
                    class="tip_works_bottom_author_right public"
                    v-if="ism == 'M'"
                    @click="lickClick"
                  >
                    {{ tiplist.like_num }}
                  </div>
                </div>
              </div>
            </div>
            <div class="tip_works_right" v-if="ism == 'PC'">
              <div class="tip_works_right_title">
                <p></p>
                TA的其他作品
                <p></p>
              </div>
              <div class="tip_works_right_content">
                <div
                  class="tip_works_right_swpleft public"
                  @click="rightswprev"
                ></div>
                <el-carousel
                  ref="swp_right"
                  indicator-position="none"
                  arrow="never"
                  :autoplay="false"
                >
                  <el-carousel-item v-for="item in tiprightimg" :key="item.id">
                    <img
                      :src="item.m_info.thumbnail_url"
                      @click="swp_rightClick(item)"
                    />
                  </el-carousel-item>
                </el-carousel>
                <div
                  class="tip_works_right_swpright"
                  @click="rightswpnext"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 活动规则 -->
      <div class="tip_rulesbox" v-if="tip == 2">
        <div class="tip_rules">
          <div class="tip_worksbox_guan public" @click="tipchange(false)"></div>
          <div class="tip_rules_title">
            <div class="tip_rules_title_icon public"></div>
            <div>活动规则</div>
            <div class="tip_rules_title_icon public"></div>
          </div>
          <div class="tip_rules_content">
            <p>
              ①指挥官可以根据《梦幻模拟战》手游中英雄或士兵的形象为他们创作皮肤，投稿作品参赛~
            </p>
            <p>
              ②本次赛事共分【英雄皮肤】与【士兵皮肤】两个赛区，两赛区可同时参赛，每天最多只能投稿三次，首次投稿任意赛区的指挥官可获得惊喜小礼物一份。
            </p>
            <p>③活动具体规则见下方。</p>
            <p class="tip_rules_content_title">活动时间：</p>
            <p>投稿时间：8月6日—9月3日</p>
            <p>审核时间：9月4日—9月9日</p>
            <p>结果公示：9月10日</p>
            <p class="tip_rules_content_title">一活动评奖流程：</p>
            <p>
              1.作品提交后，需先对作品进行基础审核（主题、原创性等），审核时间在3个工作日左右，审核通过后将在首页进行展示；
            </p>
            <p>
              2.投稿时间截止后，将由官方评审团对作品的画面完成度、主题符合程度、人设符合程度和人气值等进行综合评选，审核时间为5个工作日，将在页面公布最终评选结果；
            </p>
            <p>
              3.人气奖为每个赛区点赞数前5位的作品，每人仅可获得1次人气奖，若同一个人的两个作品在两个赛区的人气值均达到前五，则选择人气较高的赛区发奖，另一个赛区奖励顺延；如票数并列则可同时获得奖励。每人每天可拥有5次投票机会，每个作品每天仅可被投票1次；
            </p>
            <p>
              4.单个赛区每人仅可获得1次奖励，取最高奖励发放，两个赛区可各获得1次奖励。
            </p>
            <p class="tip_rules_content_title">二投稿规则：</p>
            <p>
              1.作品需围绕《梦幻模拟战》为主题进行创作，作品必须为手游中的角色及士兵，不得出现其他作品中的角色；
            </p>
            <p>
              2.本次活动征集绘画作品，不限制板绘或手绘等，图片大小不超过5M，格式为jpg及png均可；
            </p>
            <p>3.每个玩家投稿数量不限，每天最多投稿3次；</p>
            <p>
              4.投稿作品必须为原创作品，参赛选手须对参赛作品的版权、著作权以及肖像权负法律责任。
            </p>
            <p>
              如参赛者因剽窃他人作品而产生法律纠纷，由参赛者承担法律责任，与主办及承办单位无关；且因剽窃他人作品而产生纠纷的作品将无法继续参与本次活动；
            </p>
            <p>
              5.本次活动投稿作品要求首次公开发表，且获奖评选将优先考虑首次公开发表的作品；
            </p>
            <p>
              6.作品、标题健康向上和谐，不涉及色情、暴力以及和国家法律相抵触的内容。带有商业推广意图的广告内容，不和谐内容等视为无效作品。
            </p>
            <p>
              7.未经主办方同意，参赛者在参赛期间不得将参赛作品自行用于商业用途或授予任何第三方使用，否则取消获奖资格；
            </p>
            <p>
              8.作品一经投稿，即视为默认《梦幻模拟战》手游官方有合理使用其参赛作品的权利，但保留作者署名权，包括并不限于在自媒体平台中进行推广宣传等；
            </p>
            <p>
              9.活动禁止刷数据等破坏比赛公平原则的行为，情节严重者取消参赛资格；
            </p>
            <p class="tip_rules_content_title">三其他注意事项：</p>
            <p>
              为保证发奖的顺利，请在投稿时务必保证您的游戏信息及QQ号手机号等联系方式填写正确，
            </p>
            <p>
              工作人员将在获奖结果公布后5个工作日内联系获奖人员，请保证联系方式畅通，否则逾期无效。
            </p>
            <p>奖品将在收齐信息后30个工作日内寄出，请耐心等待。</p>
            <p class="tip_rules_content_title">
              *本次活动在法律允许范围内的解释权归《梦幻模拟战》手游所有。
            </p>
          </div>
        </div>
      </div>
      <!-- 提示弹框 -->
      <div class="tip_promptbox" v-if="tip == 3">
        <div class="tip_prompt">
          <div class="tip_worksbox_guan public" @click="tipchange(false)"></div>
          <div class="tip_prompt_title">{{ prompt_title }}</div>
          <div class="tip_prompt_content">
            {{ prompt_content }}
          </div>
        </div>
      </div>
      <!-- 上传作品 -->
      <div class="tip_uploadbox" v-if="tip == 4">
        <div class="tip_upload">
          <div class="tip_worksbox_guan public" @click="tipchange(false)"></div>
          <el-form
            ref="form"
            :model="form"
            :rules="uploadrules"
            label-width="80px"
          >
            <el-form-item label="选择赛区" prop="skin"
              ><el-radio-group v-model="form.skin">
                <el-radio label="9">英雄皮肤</el-radio>
                <el-radio label="10">士兵皮肤</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="作品标题" prop="title">
              <el-input
                ref="addForm"
                v-model="form.title"
                maxlength="12"
                placeholder="请输入作品标题，字数控制在12个汉字以内 "
              ></el-input>
            </el-form-item>
            <el-form-item label="作者" prop="name">
              <el-input
                v-model="form.name"
                maxlength="15"
                placeholder="请输入您的昵称"
              ></el-input>
            </el-form-item>
            <el-form-item label="作品简介"
              ><el-input
                type="textarea"
                placeholder="作品简介不超过30个字"
                v-model="form.introduce"
                maxlength="30"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item label="您的QQ号" prop="QQ">
              <el-input
                v-model="form.QQ"
                type="number"
                oninput="if(value.length>11)value=value.slice(0,11)"
                placeholder="请输入您的QQ号"
              ></el-input>
            </el-form-item>
            <el-form-item class="uploadimg" label="上传图片" prop="img">
              <ul class="pic-box fl">
                <li ref="li1">
                  <span class="remove_btn" @click="removeFile(1)"></span>
                  <input
                    ref="addimg1"
                    :type="file1"
                    accept="image/*"
                    class="file-btn"
                    @change="addFile($event, 1)"
                  />
                  <div v-if="form.thumbnailsrc1">
                    <img :src="form.thumbnailsrc1" />
                  </div>
                  <span ref="progress1" class="progress_line"></span>
                </li>
                <li>
                  <span class="remove_btn" @click="removeFile(2)"></span>
                  <input
                    ref="addimg2"
                    :type="file1"
                    accept="image/*"
                    class="file-btn"
                    @change="addFile($event, 2)"
                  />
                  <div v-if="form.thumbnailsrc2">
                    <img :src="form.thumbnailsrc2" />
                  </div>
                  <span ref="progress2" class="progress_line"></span>
                </li>
                <li>
                  <span class="remove_btn" @click="removeFile(3)"></span>
                  <input
                    ref="addimg3"
                    :type="file1"
                    accept="image/*"
                    class="file-btn"
                    @change="addFile($event, 3)"
                  />
                  <div v-if="form.thumbnailsrc3">
                    <img :src="form.thumbnailsrc3" />
                  </div>
                  <span ref="progress3" class="progress_line"></span>
                </li>
              </ul>
            </el-form-item>
          </el-form>
          <div class="tip_upload_prompt">
            <div
              class="uploadprompt"
              v-if="
                thumbnailsrcFlag &&
                !form.thumbnailsrc1 &&
                !form.thumbnailsrc2 &&
                !form.thumbnailsrc3
              "
            >
              请添加图片
            </div>
            <p>最多添加3张图片（支持PNG和JPG格式，大小不超过5M）</p>
            <p>投稿成功后需要一定的时间进行人工审核，请您耐心等待</p>
          </div>
          <div class="tip_upload_bottombtnbox">
            <div class="tip_upload_bottombtn">
              <div class="tip_upload_submit public" @click="submissionClick">
                提交
              </div>
              <div class="tip_upload_reset public" @click="resetClick">
                重置
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 登录 -->
      <div class="tip_loginbox" v-if="tip == 5">
        <div class="tip_login">
          <div class="tip_worksbox_guan public" @click="tipchange(false)"></div>
          <div class="tip_login_title">
            <span class="public"></span>
            <div>登录</div>
            <span class="public"></span>
          </div>
          <div class="tip_login_content">
            <p>账号ID</p>
            <el-input v-model="loginInput"></el-input>
            <div class="tip_upload_idicon" @click="loginimgClick">?</div>
            <img v-if="loginimg" src="@/assets/img/pc/question_con.jpg" />
          </div>
          <div class="tip_login_prompt" v-show="login_prompt">
            请指挥官输入账号ID
          </div>
          <div class="tip_loginbox_btnbox">
            <div class="tip_loginbox_btn public" @click="submitlogin">确定</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screenflage" class="screenbox">
      <img :src="screenimg" />
      <div class="screenbox_guan public" @click="screenClose('')"></div>
    </div>
    <!-- 底部 -->
    <div id="footer" class="footer">
      <div class="footBox" style="position: relative">
        <div class="logo2">
          <a href="//www.zlongame.com" target="_blank"
            ><img
              class="logoimg"
              src="//fs.zilongame.com/images/logo3.png"
              alt=""
          /></a>
        </div>
        <div class="text">
          <p>
            <a
              class="f_no"
              href="//www.zlongame.com/html/progress.html"
              target="_blank"
              >关于紫龙</a
            ><em class="f_no">|</em>
            <a
              class="f_no"
              href="//www.zlongame.com/html/service.html"
              target="_blank"
              >客服中心</a
            ><em class="f_no">|</em>
            <a
              class="f_no"
              href="//www.zlongame.com/html/parIndex.html"
              target="_blank"
              >家长监护</a
            ><em class="f_no">|</em>
            <a href="javascript:;" target="_blank"
              ><span>适龄提示：本网站提供的游戏适合18岁以上的玩家</span></a
            >
          </p>
          <p>ICP备案号：京ICP备15063824号</p>
          <p>
            北京紫御科技有限公司版权所有 COPYRIGHT © 2015 ZLONGAME.COM LIMITED.
            ALL RIGHTS RESERVED.
          </p>
          <p>
            京公网安备 11010502034977号 京ICP证160189号 &nbsp;<a
              href="//sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/4028c08e537426a10153cb69281b0ed5"
              target="_blank"
              style="display: inline-block"
              ><img
                src="//www.zlongame.com/common/ui/gov/1.0.0/wen.png"
                style="vertical-align: bottom" /></a
            >文网文：京网文〔2018〕11178-1019号 &nbsp;文网游备字〔2018〕Ｍ-SLG
            0068 号
          </p>
          <p>
            批准文号：新广出审〔2017〕5365 号&nbsp;出版物号：ISBN
            978-7-7979-8878-0
          </p>
        </div>
        <div class="bq">
          <a
            href="//sq.ccm.gov.cn/ccnt/sczr/service/business/emark/gameNetTag/2c94c08b61700ef401616f3617540a5a"
          >
            <img src="//www.zlongame.com/images/dzbq.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import lrz from "lrz";
import * as _code from "../utils/code.js";
import reward from "../components/pc/reward.vue";
import works from "../components/pc/works.vue";
import winning from "../components/pc/winning.vue";
import http from "../api/http";
export default {
  name: "pc",
  components: { reward, works, winning },
  props: {
    ism: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      endFlag: "false",
      file1: "file",
      login_prompt: false,
      tiplist: { m_info: { thumbnail_url: "" } }, //详情弹框介绍
      screenimg: "", //全屏图片
      screenflage: false, //全屏弹框
      Upload_imgnum: "", //上传图片的区分编号
      role_id: "",
      role_name: "",
      thumbnailsrcFlag: false,
      loginimg: false,
      loginInput: "",
      end: "end",
      false: false,
      tipflag: false,
      loginflag: false,
      tip: 4,
      form: {
        skin: "",
        title: "",
        name: "",
        introduce: "",
        QQ: "",
        img: "",
        thumbnailsrc1: "", //上传缩略图地址
        thumbnailsrc2: "", //上传缩略图地址
        thumbnailsrc3: "", //上传缩略图地址
        detailedsrc1: "", //详细图地址
        detailedsrc2: "", //详细图地址
        detailedsrc3: "", //详细图地址
      },
      uploadrules: {
        skin: [{ required: true, message: "请选择赛区", trigger: "blur" }],
        title: [{ required: true, message: "请输入作品标题", trigger: "blur" }],
        name: [{ required: true, message: "请输入作者名字", trigger: "blur" }],
        QQ: [{ required: true, message: "请输入您的QQ信息", trigger: "blur" }],
        img: [{ required: true }],
      },
      src1: "",
      src2: "",
      src3: "",
      uploadid: 0,
      tipleftimg: [],
      tiprightimg: [],
      prompt_title: "", //提示弹框标题
      prompt_content: "", //提示弹框内容
      //上传腾讯云
      qaFlag: /^(test|qa)-/.test(location.hostname),
      // w: "",
      // 请求用到的参数
      Bucket: "tongren-1251257918",
      Region: "ap-shanghai",
      protocol: location.protocol === "https:" ? "https:" : "http:",
    };
  },
  watch: {
    loginInput(ne) {
      if (ne) {
        this.login_prompt = false;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //初始状态
      let id = localStorage.getItem("role_id");
      let name = localStorage.getItem("role_name");
      if (id && name) {
        this.role_name = name;
        this.role_id = id;
      }
      // 获取服务器时间
      $.ajax({
        type: "head",
        success: (a, b, c) => {
          this.endFlag = false;
          var _time = +new Date(c.getResponseHeader("date")).getTime();
          var _endTime = new Date("2021/9/4").getTime();
          if (_time - _endTime >= 0) this.endFlag = true;
        },
      });
    },
    exitClick() {
      //退出登录
      localStorage.removeItem("role_id");
      localStorage.removeItem("role_name");
      this.role_name = "";
      this.role_id = "";
      location.reload();
    },
    submitlogin() {
      //登录提交
      if (this.loginInput) {
        let obj = {
          roleid: this.loginInput,
          game_id: 6,
          sign: this.$md5(`9e5b6610aa8614abb26e0617f09c3d2e${this.loginInput}`),
        };
        http.login(qs.stringify(obj)).then((res) => {
          let data = res.data;
          if (data.code == 0) {
            this.role_name = data.roleInfoList[0].role_name;
            this.role_id = data.roleInfoList[0].role_id;
            window.localStorage.setItem("role_id", this.role_id),
              window.localStorage.setItem("role_name", this.role_name);
            this.tipchange(false);
          } else {
            let code = data.code;
            let voteErr = _code.code.vote;
            let msg = voteErr[code] ? voteErr[code] : voteErr["other"] + code;
            this.promptTip(true, 3, "登录失败", msg);
          }
        });
      } else {
        this.login_prompt = true;
      }
    },
    lickClick() {
      //点赞
      this.$refs.works.lickClick(this.tiplist, 1);
    },
    lickAdd() {
      this.tiplist.like_num++;
    },
    submissionClick() {
      //投稿提交
      let emojiRule =
        /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      let imgflag =
        this.form.thumbnailsrc1 ||
        this.form.thumbnailsrc2 ||
        this.form.thumbnailsrc3;
      if (!imgflag) {
        this.thumbnailsrcFlag = true;
      }
      let flag =
        this.form.skin &&
        this.form.title &&
        this.form.name &&
        this.form.QQ &&
        imgflag;
      if (
        this.form.title.match(emojiRule) ||
        this.form.introduce.match(emojiRule) ||
        this.form.name.match(emojiRule) ||
        this.form.QQ.match(emojiRule)
      ) {
        this.$message("不能输入emoji表情");
        return;
      }
      if (flag) {
        let imgobj = {
          url1: this.form.detailedsrc1,
          thumbnail_url1: this.form.thumbnailsrc1,
          url2: this.form.detailedsrc2,
          thumbnail_url2: this.form.thumbnailsrc2,
          url3: this.form.detailedsrc3,
          thumbnail_url3: this.form.thumbnailsrc3,
        };

        let obj = {
          appkey: 1486458782785,
          type: this.form.skin,
          roleid: this.role_id,
          rolename: this.form.name,
          tags: this.form.introduce,
          tongren_name: this.form.title,
          json_info: JSON.stringify(imgobj),
          qq: this.form.QQ,
        };
        http.contribute(qs.stringify(obj)).then((res) => {
          let data = res.data;
          if (data.info == 1) {
            if (data.data.fristSubmission == 1) {
              this.promptTip(
                true,
                3,
                "首次投稿成功！",
                "感谢指挥官的投稿~小礼物已发送至您的邮箱~请注意查收~"
              );
            } else {
              this.promptTip(true, 3, "投稿成功", "恭喜投稿成功");
            }
            this.resetClick();
          } else {
            let code = data.info;
            let voteErr = _code.code.vote;
            let msg = voteErr[code] ? voteErr[code] : voteErr["other"] + code;
            this.promptTip(true, 3, "投稿失败", msg);
          }
        });
      } else {
        // $(".el-form-item__error").show();
        this.$message("您有未填写的必填内容");
      }
    },
    loginimgClick() {
      this.loginimg = !this.loginimg;
    },
    loginClick() {
      //登录
      if (this.endFlag) {
        this.promptTip(true, 3, "", "活动已结束！");
        return;
      }
      this.loginInput = "";
      this.tip = 5;
      this.tipflag = true;
    },
    uplodClick(id) {
      //上传作
      if (this.endFlag) {
        this.promptTip(true, 3, "", "活动已结束！");
        return;
      }
      if (this.role_name && this.role_id) {
        // $(".el-form-item__error").hide();
        this.thumbnailsrcFlag = false;
        this.tip = 4;
        this.form.skin = id;
        this.tipflag = true;
      } else {
        this.promptTip(
          true,
          3,
          "未登录",
          "您还未登录哦，请登录后再进行投稿吧~"
        );
        this.loginflag = true;
      }

      // this.uploadFun();
    },
    loginflagChang() {
      this.loginflag = true;
    },
    deleteimg(id) {
      if (id == 1) {
        this.src1 = "";
      }
      if (id == 2) {
        this.src2 = "";
      }
      if (id == 3) {
        this.src3 = "";
      }
    },
    tipchange(flag, serial, ids) {
      //弹框
      let _this = this;
      if (!flag && this.loginflag) {
        if (this.role_name && this.role_id) {
          this.tipflag = flag;
        } else {
          if (this.endFlag) {
            this.promptTip(true, 3, "", "活动已结束！");
          } else {
            this.loginClick();
          }
        }
        this.loginflag = false;
      } else {
        if (ids) {
          //获取详情
          let obj = {
            id: ids,
          };
          http.getDetail(qs.stringify(obj)).then((res) => {
            let data = res.data.data;
            data.obj.m_info = JSON.parse(data.obj.m_info);
            data.list.forEach((item, index) => {
              item.m_info = JSON.parse(item.m_info);
            });
            let list = data.list.filter((item) => {
              return item.id != data.obj.id;
            });
            _this.tipleftimg = [data.obj, ...list];
            _this.tiplist = _this.tipleftimg[0];
            // _this.tiprightimg = list;
            _this.tiprightimg = [data.obj, ...list];
          });
        }
        if (serial) {
          this.tip = serial;
          if (serial == 4) {
            this.uplodClick();
          }
        }
        this.tipflag = flag;
      }
    },
    promptTip(flag, id, title, content) {
      //提示弹框

      this.tip = id;
      this.prompt_title = title;
      this.prompt_content = content;
      this.tipflag = flag;
    },
    fullscreenClick(item) {
      //图片全屏
      this.screenimg = item.m_info.url;
      this.screenflage = true;
    },
    screenClose() {
      //全屏关闭
      this.screenflage = this.false;
    },
    swpprev() {
      this.$refs.swp.prev();
      this.tiplist = this.tipleftimg[this.$refs.swp.activeIndex];
    },
    swpnext() {
      this.$refs.swp.next();
      this.tiplist = this.tipleftimg[this.$refs.swp.activeIndex];
    },
    rightswprev() {
      this.$refs.swp_right.prev();
    },
    rightswpnext() {
      this.$refs.swp_right.next();
    },
    swp_rightClick(item) {
      // this.$refs.swp.setActiveItem(index + 1);
      this.tiplist = item;
    },
    resetClick() {
      //重置
      this.form = {
        skin: "",
        title: "",
        name: "",
        introduce: "",
        QQ: "",
        thumbnailsrc1: "", //上传缩略图地址
        thumbnailsrc2: "", //上传缩略图地址
        thumbnailsrc3: "", //上传缩略图地址
        detailedsrc1: "", //详细图地址
        detailedsrc2: "", //详细图地址
        detailedsrc3: "", //详细图地址
      };
      this.$refs.addimg1.value = null;
      this.$refs.addimg2.value = null;
      this.$refs.addimg3.value = null;
    },
    addFile(e, num) {
      let _this = this;
      this.Upload_imgnum = num;
      var par = $(this).parent();
      var pline = $(this).parent().find("progress_line");
      var file = e.target.files[0];
      var indexNum = file.name.lastIndexOf(".");
      var lastName = file.name.substr(indexNum + 1);
      var nameArr = ["gif", "jpg", "jpeg", "png", "GIF", "JPG", "PNG"];
      var imgFlag = false;
      for (var i = 0; i < nameArr.length; i++) {
        if (lastName == nameArr[i]) {
          imgFlag = true;
        }
      }
      setTimeout(function () {
        if (imgFlag) {
          if ((file.size / (1024 * 1024)).toFixed(3) <= 5) {
            //小于5M
            file.newName =
              // $(".userInfo").val() +
              "_" + +new Date() + "." + file.name.split(".")[1];
            try {
              lrz(file, { width: 1024 })
                .then(function (rst) {
                  rst.file.newName =
                    file.newName.split(".")[0] +
                    "_ys." +
                    file.newName.split(".")[1];
                  rst.file &&
                    _this.uploadFile(rst.file, function (err, data) {
                      if (data) {
                        // par.attr("thumbnail_url", data.url);rst.base64
                        switch (_this.Upload_imgnum) {
                          case 1:
                            _this.form.thumbnailsrc1 = data.url;
                            break;
                          case 2:
                            _this.form.thumbnailsrc2 = data.url;
                            break;
                          case 3:
                            _this.form.thumbnailsrc3 = data.url;
                            break;
                        }
                      } else {
                        // tip(false, err);
                        // _this.promptTip(true, 3, "上传失败", err);
                        _this.$message(err);
                      }
                    });
                })
                .always(function () {
                  // return;
                  file &&
                    _this.uploadFile(
                      file,
                      function (err, data) {
                        if (data) {
                          switch (_this.Upload_imgnum) {
                            case 1:
                              _this.form.detailedsrc1 = data.url;
                              break;
                            case 2:
                              _this.form.detailedsrc2 = data.url;
                              break;
                            case 3:
                              _this.form.detailedsrc3 = data.url;
                              break;
                          }
                          par.attr("url", data.url);
                        } else {
                          // this.promptTip(true, 3, "上传失败", err);
                          _this.$message(err);
                        }
                      },
                      par
                    );
                });
            } catch (err) {
              // _this.promptTip(true, 3, "上传失败", err);
              _this.$message(err);
            }
          } else {
            _this.$message("图片太大啦！请选择5M以内的图片上传哦~");
            _this.file1 = "text";
            setTimeout(function () {
              _this.file1 = "file";
            }, 30);
          }
        } else {
          _this.$message("图片格式不对，请选择PNG或者JPG形式上传哦~");
        }
      }, 600);
      // })
    },
    // 计算签名
    getAuthorization(options, callback) {
      let tokenUrl = this.qaFlag
        ? "//activitytest.zlongame.com/activity/branch/tr/getAccessToken.do"
        : "//activity.zlongame.com/activity/branch/tr/getAccessToken.do";
      var url = tokenUrl;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.onload = function (e) {
        var credentials;
        try {
          credentials = new Function("return " + xhr.responseText)()
            .credentials;
          //credentials = xhr.responseText.credentials;
          // console.info(credentials);
        } catch (e) {}
        if (credentials) {
          callback(null, {
            XCosSecurityToken: credentials.sessionToken,
            Authorization: CosAuth({
              SecretId: credentials.tmpSecretId,
              SecretKey: credentials.tmpSecretKey,
              Method: options.Method,
              Pathname: options.Pathname,
            }),
          });
        } else {
          // console.error(xhr.responseText);
          callback("获取签名出错");
        }
      };
      xhr.onerror = function (e) {
        callback("获取签名出错");
      };
      xhr.send();
    },
    uploadFile(file, callback, obj) {
      var self = this;
      var Key = "mhmnz/tongren/" + file.newName; // 这里指定上传目录和文件名
      self.getAuthorization(
        { Method: "PUT", Pathname: "/" + Key },
        function (err, info) {
          if (err) {
            alert(err);
            return;
          }
          let prefix =
            self.protocol +
            "//" +
            self.Bucket +
            ".cos." +
            self.Region +
            ".myqcloud.com/";
          var auth = info.Authorization;
          var XCosSecurityToken = info.XCosSecurityToken;
          var url = prefix + self.camSafeUrlEncode(Key).replace(/%2F/, "/");
          var xhr = new XMLHttpRequest();
          xhr.open("PUT", url, true);
          xhr.setRequestHeader("Authorization", auth);
          XCosSecurityToken &&
            xhr.setRequestHeader("x-cos-security-token", XCosSecurityToken);
          xhr.upload.onprogress = function (e) {
            if (obj) {
            }
          };
          xhr.onload = function () {
            if (xhr.status === 200 || xhr.status === 206) {
              var ETag = xhr.getResponseHeader("etag");
              callback(null, { url: url, ETag: ETag });
            } else {
              callback("上传失败，状态码：" + xhr.status);
            }
          };
          xhr.onerror = function () {
            callback("上传失败，请检查是否配置跨域规则");
          };
          xhr.send(file);
        }
      );
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A");
    },
    removeFile(num) {
      let _this = this;
      switch (num) {
        case 1:
          _this.form.thumbnailsrc1 = "";
          _this.$refs.addimg1.value = null;
          break;
        case 2:
          _this.form.thumbnailsrc2 = "";
          _this.$refs.addimg2.value = null;
          break;
        case 3:
          _this.form.thumbnailsrc3 = "";
          _this.$refs.addimg3.value = null;
          break;
      }
    },
  },
};
</script>
<style scoped>
@import url("../assets/css/pc/index.css");
@import url("../assets/css/pc/tip.css");
@import url("../assets/css/m/index.css");
@import url("../assets/css/m/tip.css");
</style>